module.exports = __webpack_public_path__ + "img/category-new-released.7effa9f7.png";